/**
 * The pipeline's stage navigator — one tile per stage, the count on it, and a
 * one-line description of what the stage is for. It replaces the old row of
 * summary tiles: on a board that is worked stage by stage, "how many are at
 * Demo" and "jump me to Demo" are the same gesture, so the count IS the filter.
 *
 * Driven by whatever `pipelineStages(S)` returns, so it follows the workspace's
 * configured stages rather than hard-coding them. Clicking the selected tile
 * again clears the stage filter and shows the whole board.
 */
import Icon from '../lib/icons.jsx';

/* Safe icon names (Icon renders nothing for an unknown one) and a line of copy,
   keyed by the lower-cased stage. Both fall back, so a stage renamed or added
   in settings still gets a tile — just a generic icon and no description. */
const ICONS = {
  new: 'users', 'sales talk': 'phone', qualified: 'phone', contacted: 'phone',
  demo: 'cal', proposal: 'file', negotiation: 'chat', closed: 'check',
  won: 'star', lost: 'flag'
};
const DESC = {
  new: 'Just in · needs an owner',
  'sales talk': 'Call, qualify, prep for demo',
  qualified: 'Contacted and qualified',
  contacted: 'Reached out, awaiting reply',
  demo: 'Demo booked or delivered',
  proposal: 'Quote sent, in negotiation',
  negotiation: 'In negotiation',
  closed: 'Won, lost or gone quiet',
  lost: 'Lost or gone quiet'
};

export default function StageNavigator({ stages, groups, selected, onPick }) {
  const total = stages.length;
  return (
    <div className="stagenav" style={{ '--n': total }} role="tablist" aria-label="Pipeline stages">
      {stages.map((stage, i) => {
        const g = groups.find(x => x.stage === stage);
        const n = g ? g.deals.length : 0;
        const key = String(stage).toLowerCase();
        const on = selected === stage;
        return (
          <button
            key={stage}
            type="button"
            role="tab"
            aria-selected={on}
            className={on ? 'stagetile on' : 'stagetile'}
            onClick={() => onPick(on ? '' : stage)}
          >
            <span className="st-top">
              <span className="st-ic"><Icon name={ICONS[key] || 'target'} /></span>
              <span className="st-idx">{i + 1}/{total}</span>
            </span>
            <span className="st-name">{stage}</span>
            <span className="st-count">{n}</span>
            <span className="st-desc">{DESC[key] || ' '}</span>
          </button>
        );
      })}
    </div>
  );
}
